import type { FC } from 'react';
import { useEffect } from 'react';
import { useStore } from 'zustand';

import {
	emailEditorService,
	enquirySelectionService,
	ModalFlowStore,
	ModalSteps,
} from 'Features/SellerCommunications/services';
import { triggerSellerMessagingModalOpenedEvent } from 'Services/analytics/events';

import { EmailEditor } from '../EmailEditor';
import { EnquirySelection } from '../EnquirySelection';
import { EnquirySelectionError } from '../EnquirySelectionError';
import { EnquirySelectionLoading } from '../EnquirySelectionLoading';
import { MarkAsContactedConfirmation } from '../MarkAsContactedConfirmation';
import { MarkAsContactedError } from '../MarkAsContactedError';
import { MarkAsContactedLoading } from '../MarkAsContactedLoading';
import { NothingToSend } from '../NothingToSend';
import { ProcessingEmails } from '../ProcessingEmails';
import { ProcessingEmailsError } from '../ProcessingEmailsError';

export const ModalRouter: FC = () => {
	const { currentStep } = useStore(ModalFlowStore);

	useEffect(() => {
		void enquirySelectionService.onGetCommunicationData();
		void emailEditorService.onGetSellerCommunicationTemplate();
	}, []);

	useEffect(() => {
		triggerSellerMessagingModalOpenedEvent(currentStep);
	}, [currentStep]);

	const Step = {
		[currentStep]: () => null,
		[ModalSteps.EnquirySelectionLoading]: EnquirySelectionLoading,
		[ModalSteps.EnquirySelection]: EnquirySelection,
		[ModalSteps.NothingToSend]: NothingToSend,
		[ModalSteps.EnquirySelectionError]: EnquirySelectionError,
		[ModalSteps.EmailEditor]: EmailEditor,
		[ModalSteps.ProcessingEmails]: ProcessingEmails,
		[ModalSteps.ProcessingEmailsError]: ProcessingEmailsError,
		[ModalSteps.MarkAsContactedConfirmation]: MarkAsContactedConfirmation,
		[ModalSteps.MarkAsContactedLoading]: MarkAsContactedLoading,
		[ModalSteps.MarkAsContactedError]: MarkAsContactedError,
	}[currentStep];
	return <Step />;
};
